import { v4 as uuidv4 } from "uuid";
import { API_ENDPOINTS } from "constants/api";
import { customApiCall, getApiHost, IOptions } from "utils/api";
import {
    ICitiesResponse,
    IListReferralsResponse,
    IHomeBannersResponse,
    IUserDataResponse,
    ICreateReferralResponse,
    IRefereePayload,
} from "interfaces/home";
import { ICityBonusResponse } from "interfaces/cityBonus";

export const getCities = (): Promise<ICitiesResponse> => {
    const opts: IOptions = {
        method: "GET",
    };
    return customApiCall(getApiHost(), API_ENDPOINTS.GET_CITIES, opts);
};

export const getReferralsList = (): Promise<IListReferralsResponse> => {
    const payload = {
        request_id: uuidv4(),
        client_id: "mfp_portal_influencer",
        page_size: 3,
    };
    const opts: IOptions = {
        method: "POST",
        body: JSON.stringify(payload),
    };
    return customApiCall(getApiHost(), API_ENDPOINTS.LIST_REFERRALS, opts);
};

export const getHomeBanners = (): Promise<IHomeBannersResponse> => {
    const opts: IOptions = {
        method: "GET",
    };
    return customApiCall(getApiHost(), API_ENDPOINTS.GET_HOME_BANNERS, opts);
};

export const getUserData = (): Promise<IUserDataResponse> => {
    const opts: IOptions = {
        method: "GET",
    };
    return customApiCall(getApiHost(), API_ENDPOINTS.GET_USER_DATA, opts);
};

export const createReferral = (referee: IRefereePayload): Promise<ICreateReferralResponse> => {
    const payload = {
        request_id: uuidv4(),
        client_id: "mfp_portal_influencer",
        referee,
    };
    const opts: IOptions = {
        method: "POST",
        body: JSON.stringify(payload),
    };
    return customApiCall(getApiHost(), API_ENDPOINTS.CREATE_REFERRAL, opts);
};

export const getCityBonus = (): Promise<ICityBonusResponse> => {
    const opts: IOptions = {
        method: "GET",
    };
    return customApiCall(getApiHost(), API_ENDPOINTS.GET_CITY_BONUS, opts);
};
